import Button from "@/components/Button";
import { useNavigate } from "react-router-dom";
import TableSection from "./components/TableSection";
import "./style.scss";

const Users = () => {
  const navigate = useNavigate();

  return (
    <div className="users-page-wrapper">
      <div className="header-page">
        <div className="text-wrapper">
          <h1>Users</h1>
          <span className="desc">
            Update and delete user info on the Customer and Admin tabs.
          </span>
        </div>

        <Button
          label="User"
          size="md"
          startIcon="plus"
          onClick={() =>
            navigate("/users/add-user", {
              state: { procedure: "add", userId: -1 },
            })
          }
        />
      </div>

      <TableSection />
    </div>
  );
};

export default Users;
